import { render, staticRenderFns } from "./TimeTravel.vue?vue&type=template&id=54f787ee&scoped=true"
import script from "./TimeTravel.vue?vue&type=script&lang=js"
export * from "./TimeTravel.vue?vue&type=script&lang=js"
import style0 from "./TimeTravel.vue?vue&type=style&index=0&id=54f787ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f787ee",
  null
  
)

export default component.exports